{
  "WALLBOARD": {
    "LOADING": "Telefon-Warteschlangen werden geladen...",
    "NO_QUEUES": "Keine Telefon-Warteschlangen gefunden.",
    "AGENTS": "Agenten",
    "NO_AGENTS": "Keine Online-Agenten in dieser Warteschlange.",
    "NO_AGENTS_ONLINE": "Keine Online-Agenten.",
    "WAITING_CALLERS": "Wartende Anrufer",
    "NO_CALLERS": "Keine wartenden Anrufer.",
    "UNKNOWN_CALLER": "Unbekannter Anrufer",
    "POSITION": "Position",
    "STATUS": "Status",
    "TIME": "Zeit",
    "AGENT": "Agent",
    "EXTENSION": "Nebenstelle",
    "AVAILABLE": "Verfügbar",
    "READY": "Bereite Agenten",
    "ON_CALL": "Agenten im Gespräch",
    "QUEUE_CALL": "Warteschlangenanruf",
    "OTHER_CALL": "Anderer Anruf",
    "PAUSED": "Agenten in Pause",
    "WAITING": "Wartende Anrufe",
    "MISSED_CALLS": "Verpasste Anrufe",
    "HANDLED_CALLS": "Bearbeitete eingehende Anrufe",
    "OUTBOUND_CALLS": "Bearbeitete ausgehende Anrufe",
    "AVAILABILITY": "Verfügbarkeit",
    "AVAILABILITY_TOOLTIP": "Prozentsatz der eingehenden Anrufe, die von Agenten angenommen wurden (angenommene Anrufe)",
    "TOTAL": "gesamt",
    "AGENTS_COUNT": "({onCall} im Gespräch / {total} gesamt)",
    "NO_AVAILABLE": "(niemand online)",
    "WAITING_CALLERS_COUNT": "{count} wartend",
    "CALLER": "Anrufer",
    "NUMBER": "Nummer",
    "WAIT_TIME": "Wartezeit",
    "QUEUES": "Warteschlangen",
    "ACTION": "Aktion",
    "PICKUP_CALL": "Annehmen",
    "PICKING_UP": "Wird angenommen...",
    "PICKUP_SUCCESS": "Anrufannahme erfolgreich angefordert.",
    "PICKUP_ERROR": "Anruf konnte nicht angenommen werden. Bitte versuchen Sie es erneut.",
    "PICKUP_DISABLED_TOOLTIP": "Sie können einen Anruf nicht annehmen, während Sie im Gespräch oder offline sind.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Kein Zugriff"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Kein Zugriff"
    }
  }
}
